<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Maps</h5>
                  </div>
                  <!-- <small class="text-truncate text-muted">More details. <a href="https://jvectormap.com/"
                      target="_blank" title="">https://jvectormap.com/</a></small> -->
                </div>
              </div>
            </div>
            <div class="col-7 col-xl-8 text-end">

            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <div class="row clearfix">
            <div class="col-lg-12">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">World Map</h6>
                </div>
                <div class="card-body">

                  <app-worldmap></app-worldmap>
                  <!-- <div id="world-map-markers" class="jvector-map" style="height: 300px"></div> -->
                </div>
              </div>
            </div>
          </div> <!-- .row end -->

          <!--
   <div class="row clearfix">
            <div class="col-md-12 col-lg-6">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">India Map</h6>
                </div>
                <div class="card-body text-center">
                  <div id="india" style="height: 400px"></div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">USA Map</h6>
                </div>
                <div class="card-body text-center">
                  <div id="usa" style="height: 400px"></div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">UK Map</h6>
                </div>
                <div class="card-body text-center">
                  <div id="uk" style="height: 400px"></div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Australia Map</h6>
                </div>
                <div class="card-body text-center">
                  <div id="australia" style="height: 400px"></div>
                </div>
              </div>
            </div>
          </div>  -->
          <!-- .row end -->
        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>